module.exports = __webpack_public_path__ + "static/media/facebook-letter-logo.9c5520db.svg";